// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__295dB","log":"ModalInventoryLogs_log__2tgIf","date":"ModalInventoryLogs_date__3LYUh","userName":"ModalInventoryLogs_userName__25vBG"};